import cloneDeep from 'lodash/cloneDeep';

import type { EmailDetail } from '@webapp/account/src/resources/mailing/email-detail';
import type { MailFilters } from '@webapp/account/src/resources/mailing/filters';
import { initialFilters } from '@webapp/account/src/resources/mailing/filters';
import type { Mail, MailGroup } from '@webapp/account/src/resources/mailing/mailing';
import { initialMail } from '@webapp/account/src/resources/mailing/mailing';
import type { Stat } from '@webapp/account/src/resources/mailing/stat';
import { initialStat } from '@webapp/account/src/resources/mailing/stat';

export interface MailingState {
    item: Mail;
    items: Array<Mail>;
    stat: Stat;
    emailDetails: Array<EmailDetail>;
    emailDetailsPage: number;
    emailDetailsTotalCount: number;
    filters: MailFilters;
    sendDates: Array<string>;
    rawMails: Array<string>;
    csvMails: Array<string>;
    mailGroups: Array<MailGroup>;
    fetch: boolean;
    csvDownloadFetch: boolean;
    quotasFetch: boolean;
    todayEmailCount: number;
    fileUpload: boolean;
    mailListLoaded: boolean;
}

export const initialState: Readonly<MailingState> = {
    item: {
        ...cloneDeep(initialMail),
        id: 1,
    },
    items: [],
    emailDetails: [],
    emailDetailsPage: 1,
    emailDetailsTotalCount: 0,
    filters: cloneDeep(initialFilters),
    sendDates: [],
    stat: cloneDeep(initialStat),
    rawMails: [],
    csvMails: [],
    mailGroups: [],
    fetch: true,
    csvDownloadFetch: false,
    quotasFetch: false,
    todayEmailCount: 0,
    fileUpload: false,
    mailListLoaded: false,
};
